module.exports = __webpack_public_path__ + "static/media/tron_2.54491136.gif";